// @spec NIS2-STR-076
import { createFileRoute, Navigate } from '@tanstack/react-router';

import { ReminderSettingsPage } from '@/features/nis2/settings/reminder-settings/ReminderSettingsPage';
import { useOrgRole } from '@/hooks/use-org-role';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/settings/nis2/reminders')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2AutomatedReminders'),
  }),
  component: NIS2RemindersSettingsRoute,
});

function NIS2RemindersSettingsRoute() {
  const { isAdmin, isLoading } = useOrgRole();

  if (isLoading) {
    return null;
  }

  if (!isAdmin) {
    return <Navigate to="/settings" />;
  }

  return <ReminderSettingsPage />;
}
